/**
 * Build a display name from the user record.
 *  - Preferred: "Nome Cognome." (first name full + last name initial + dot)
 *  - Fallback (legacy users w/o first/last): split `name` field on whitespace
 *  - Ultimate fallback: local part of masked email
 */
export const displayName = (u) => {
  if (!u) return "";
  const first = (u.first_name || "").trim();
  const last = (u.last_name || "").trim();
  if (first || last) {
    const li = last ? `${last[0].toUpperCase()}.` : "";
    return [first, li].filter(Boolean).join(" ");
  }
  const parts = (u.name || "").trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0]} ${parts[parts.length - 1][0].toUpperCase()}.`;
  }
  return parts[0] || (u.email ? u.email.split("@")[0] : "");
};
